import {
  AtlasCaption,
  AtlasColor,
  CardComponent,
  PageContentAtom,
  SecondaryButtonAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { StackAtom } from 'components/atoms/Stack.atom'
import { CircularProgressMolecule } from 'components/molecule/CircularProgress.molecule'
import { useTokenGenerator } from './TokenGenerator.hook'

const TokenGeneratorPage = () => {
  const {
    progressValue,
    otpCode,
    loading,
    durationInMinutes,
    otpTypeLabel,
    actions
  } = useTokenGenerator()

  return (
    <>
      <ToolbarMolecule
        title={otpTypeLabel}
        actionIcon="close"
        onAction={actions.goBack}
      />

      <PageContentAtom>
        <StackAtom $gap={70} $direction="column" $align="center">
          <CardComponent
            $variant="highlight"
            style={{ background: '#282828', padding: '14px 18px' }}
          >
            <StackAtom $gap={10} $align="center">
              <Icon
                name="ic_information"
                size={24}
                color={AtlasColor.TextStroke}
              />

              <AtlasCaption>
                El código será válido durante {durationInMinutes} minuto(s)
                después de solicitarlo.
              </AtlasCaption>
            </StackAtom>
          </CardComponent>

          <CircularProgressMolecule
            text={otpCode}
            value={progressValue}
            size={230}
            loading={loading}
          />

          <SecondaryButtonAtom
            type="button"
            style={{ background: '#212121' }}
            onClick={actions.generateNewOTP}
          >
            Solicitar nuevo código
          </SecondaryButtonAtom>
        </StackAtom>
      </PageContentAtom>
    </>
  )
}

export default TokenGeneratorPage
